"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WS_PUBLIC_NOTIFICATION_COUNT_UPDATED = exports.WS_PUBLIC_NOTIFICATION_CREATED = void 0;
exports.WS_PUBLIC_NOTIFICATION_CREATED = 'ws-public-notification-created';
exports.WS_PUBLIC_NOTIFICATION_COUNT_UPDATED = 'ws-public-notification-count-updated';
//# sourceMappingURL=eventType.js.map